import React, {ReactElement} from "react";

import {css} from "/src/utils/utils";
import translate from "/src/utils/translate";

import CheckIcon from "/src/svg/check.svg";
import Icon from "../../icon/Icon";

import * as styles from "./steps.module.scss";

interface StepsProps {
  activeStep: number;
  labels: Array<string>;
}

const Steps = (props: StepsProps): ReactElement => {
  const {activeStep, labels} = props;

  return (
    <div className={css(styles.steps)}>
      <ol
        className={css(styles.steps__list)}
        aria-label={translate("Form progress status")}
      >
        {labels.map((_item, idx) => {
          const isComplete = idx < activeStep;
          const isActive = idx === activeStep;
          const stepIndex = idx + 1;

          return (
            <li
              key={`form-steps-${stepIndex}`}
              className={css(
                styles.steps__item,
                idx > 0 ? styles.steps__item__line : "",
                isActive || isComplete ? styles.steps__item__lineCompleted : ""
              )}
            >
              <div
                className={css(
                  styles.steps__item__indicator,
                  isActive ? styles.steps__item__indicatorActive : "",
                  isComplete ? styles.steps__item__indicatorCompleted : ""
                )}
              >
                {isComplete ? (
                  <Icon
                    svg={CheckIcon}
                    alt={translate("completed")}
                    role="img"
                    classes={styles.steps__item__icon}
                  />
                ) : (
                  <span
                    className={css(
                      "p",
                      styles.steps__item__indicatorLabel,
                      isActive ? styles.steps__item__indicatorLabelActive : ""
                    )}
                  >
                    {stepIndex}
                  </span>
                )}
              </div>
              <span className={css("p", styles.steps__item__label)}>
                {labels && labels[idx] !== undefined && labels[idx] !== "" ? (
                  labels[idx]
                ) : (
                  <>
                    {translate("step")} {stepIndex}
                  </>
                )}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default Steps;
